import { gql, useQuery } from "@apollo/client"

const USER_TRAINING_FIELDS = `
  id
  course
  name
  dueAt
  status {
    modules {
      id
      name
      knowledges {
        id
        knowledge {
          id
          title
        }
        completedAt
      }
      percentComplete
      completedAt
      status
    }
    activeKnowledge
    activeModule
    percentComplete
    completedAt
  }
  author { firstName lastName }
  createdAt
`

const USER_TRAININGS_QUERY = gql`
  query UserTrainings($user: ID!) {
    userTrainings(user: $user) {
      ${USER_TRAINING_FIELDS}
    }
  }
`

const useQueryUserTrainings = (options) => useQuery(USER_TRAININGS_QUERY, options)

export { useQueryUserTrainings, USER_TRAINING_FIELDS }
